import styled from 'styled-components'
let StyledContact;
export default StyledContact = styled.div`
  @media (max-width: 413px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (min-width: 414px) and (max-width: 767px) {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    display: flex;
    flex-direction: row;
    justify-content:space-around;
    margin-bottom: 30px;
  }
  @media (min-width: 1024px) and (max-width: 1439px) {
    display: flex;
    flex-direction: row;
  }
  @media (min-width: 1440px) and (max-width: 1499px) {
    display: flex;
    flex-direction: column;
    justify-content:center;
  }
  @media (min-width: 1500px) {
    display: flex;
    flex-direction: column;
    justify-content:center;
  }
`;